export const getDomainType = (): 'customer' | 'admin' => {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  
  console.log('🌐 Domain detection:', { hostname, pathname });
  
  // Always use admin type for Lovable sandbox domains with /admin path
  if (hostname.includes('lovable.dev') || hostname.includes('lovable.app')) {
    if (pathname.startsWith('/admin')) {
      console.log('🌐 Detected admin via Lovable domain + admin path');
      return 'admin';
    }
  }
  
  // Check if current path starts with /admin
  if (pathname.startsWith('/admin')) {
    console.log('🌐 Detected admin via pathname');
    return 'admin';
  }
  
  // Check if it's admin domain
  if (hostname.includes('adminsmartpay') || hostname.includes('admin')) {
    console.log('🌐 Detected admin via hostname');
    return 'admin';
  }
  
  // Check for admin port (for development)
  if (hostname.includes('localhost') && window.location.port === '3001') {
    console.log('🌐 Detected admin via localhost port');
    return 'admin';
  }
  
  console.log('🌐 Defaulting to customer domain');
  // Default to customer for all other domains
  return 'customer';
};

export const isAdminDomain = (): boolean => {
  return getDomainType() === 'admin';
};

export const isCustomerDomain = (): boolean => {
  return getDomainType() === 'customer';
};

export const getAppTitle = (): string => {
  const domainType = getDomainType();
  return domainType === 'admin' 
    ? 'Money+ E Wallet Admin' 
    : 'Money+ E Wallet';
};

export const getBaseRoutes = () => {
  const domainType = getDomainType();
  
  if (domainType === 'admin') {
    return {
      dashboard: '/admin/dashboard',
      login: '/admin/login',
      home: '/admin/dashboard'
    };
  }
  
  return {
    dashboard: '/dashboard',
    login: '/auth',
    home: '/'
  };
};